import React, { useState, useRef } from "react";
import addDrivingLicense from "../../../../../../../assets/images/addDriver/addDrivingLicense.svg";
import "./AddDriverLicense.scss";
import Icon from "app/views/commonComponents/Icon/Icon";
import ResizeableCropper from "app/views/commonComponents/ResizeableCropper/ResizeableCropper";
import Slider from "antd/es/slider";
//import CropEasy from "app/views/commonComponents/Crop/CropEasy";
const AddDriverLicense = ({ onFrontImageSelect, onBackImageSelect }) => {
  const [selectedFrontImage, setSelectedFrontImage] = useState(null);
  const [selectedBackImage, setSelectedBackImage] = useState(null);
  const fileFrontInputRef = useRef(null);
  const fileBackInputRef = useRef(null);
  const [openCrop, setOpenCrop] = useState(false);
  const DL_ASPECT_RATIO = 1.59;
  const fileFrontSelectHandler = (event) => {
    const file = event.target.files[0];
    setSelectedFrontImage(file);
    //setOpenCrop(true);
    onFrontImageSelect(file); // Pass selected front image to parent component
    event.target.value = null;
    // Handle file upload
  };
  const fileBackSelectHandler = (event) => {
    const file = event.target.files[0];
    setSelectedBackImage(file);
    onBackImageSelect(file); // Pass selected back image to parent component
    event.target.value = null;
    // Handle file upload
  };
  const handleButtonFrontClick = () => {
    fileFrontInputRef.current.click();
  };
  const handleButtonBackClick = () => {
    fileBackInputRef.current.click();
  };
  return (
    <div className="uploadImageSection">
      <div className="frontSideUploadSection" style={{ width: "100%" }}>
        <div className="frontSideTitle">
          <div className="dlStyle">Driving License</div>
          <div className="fsStyle"> Front Side</div>
        </div>

        <div className="frontSideUploadInput">
          {selectedFrontImage ? (
            <>
              <div className="imageWrapper">
                {/* <CropEasy
                  {...{
                    selectedFrontImage,
                    setOpenCrop,
                    setSelectedFrontImage,
                    setFile,
                  }}
                /> */}
                <img
                  src={URL.createObjectURL(selectedFrontImage)}
                  alt="Selected"
                  style={{ maxWidth: "100%", maxHeight: "200px" }}
                />
                <Icon
                  size="regular"
                  buttonType="secondary"
                  image={addDrivingLicense}
                  onClick={handleButtonFrontClick}
                  className="uploadIcon"
                ></Icon>
              </div>
            </>
          ) : (
            <Icon
              size="regular"
              buttonType="secondary"
              image={addDrivingLicense}
              onClick={handleButtonFrontClick}
            ></Icon>
          )}
          <input
            style={{ display: "none" }}
            type="file"
            accept="image/*"
            onChange={fileFrontSelectHandler}
            ref={fileFrontInputRef}
          />
        </div>
      </div>
      <div className="backSideUploadSection" style={{ width: "100%" }}>
        <div className="frontSideTitle">
          <div className="dlStyle">Driving License</div>
          <div className="fsStyle"> Back Side</div>
        </div>
        <div className="frontSideUploadInput">
          {selectedBackImage ? (
            <div className="imageWrapper">
              <img
                src={URL.createObjectURL(selectedBackImage)}
                alt="Selected"
                style={{ maxWidth: "100%", maxHeight: "200px" }}
              />
              <Icon
                size="regular"
                buttonType="secondary"
                image={addDrivingLicense}
                onClick={handleButtonBackClick}
                className="uploadIcon"
              ></Icon>
            </div>
          ) : (
            <Icon
              size="regular"
              buttonType="secondary"
              image={addDrivingLicense}
              onClick={handleButtonBackClick}
            ></Icon>
          )}
          <input
            style={{ display: "none" }}
            type="file"
            accept="image/*"
            onChange={fileBackSelectHandler}
            ref={fileBackInputRef}
          />
        </div>
      </div>
    </div>
  );
};

export default AddDriverLicense;
